<script setup lang="ts">
import { GpModal, GpText } from '@gportal/uikit';
import type { GetRemoteConsoleAccessResponse } from 'gpcore-grpc/gpcore/api/cloud/v1/responses_pb';
import { useNodeStore } from 'gpcore-apikit/store/pinia/node';
import ModalFooterBtn from 'gpcore-uikit/components/new/ModalFooterBtn.vue';
import ExternalLink from 'gpcore-uikit/components/Component.ExternalLink.vue';
import { computed, ref } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';

withDefaults(
  defineProps<{
    show: boolean;
  }>(),
  {
    show: false,
  },
);

const emit = defineEmits<{ (e: 'created'); (e: 'close') }>();

const nodeStore = useNodeStore();

const node = computed(() => nodeStore.node);
const consoleAccessCredentials = ref<GetRemoteConsoleAccessResponse>();

nodeStore
  .getRemoteConsoleAccess(nodeStore.node)
  .then((response: GetRemoteConsoleAccessResponse) => {
    consoleAccessCredentials.value = response;
  });
const openInNewTab = () => {
  window.open(
    `https://${node.value.id}.${consoleAccessCredentials.value.hostname}/gpsession?token=${consoleAccessCredentials.value.token}`,
    '_blank',
  );
};
</script>

<template>
  <!-- TODO: check this -->
  <GpModal
    :is-opened="show"
    :header-icon="['fas', 'terminal']"
    header-text="Access platform management"
    @close="emit('close')"
    @confirm="openInNewTab"
  >
    <template #content>
      <div v-if="consoleAccessCredentials !== null" class="tw-px-4 tw-py-8">
        <p class="tw-mb-4">
          Use the following credentials to login to the platform management console. Depending on
          the hardware manufacturer of the mainboard, the console may be different. For user guides
          consult the documentation for
          <ExternalLink
            url="https://support.hpe.com/hpesc/public/docDisplay?docId=a00105236en_us&docLocale=en_US"
            >iLO (HPE)</ExternalLink
          >,
          <ExternalLink
            url="https://www.dell.com/support/manuals/en-us/idrac9-lifecycle-controller-v4.x-series/idrac9_4.00.00.00_ug_new/overview-of-idrac?lwp=rt"
            >iDRAC (Dell)</ExternalLink
          >,
          <ExternalLink url="https://www.supermicro.com/manuals/other/Embedded_BMC_IPMI.pdf"
            >IPMI (Supermicro)</ExternalLink
          >
          and
          <ExternalLink url="https://www.asrockrack.com/support/IPMI.pdf"
            >ASRR (ASRock Rack)</ExternalLink
          >.
        </p>
        <div class="tw-flex">
          <div class="tw-w-1/4">Username</div>
          <div class="tw-w-3/4">
            <GpText :text="consoleAccessCredentials.username" allow-copy />
          </div>
        </div>
        <div class="tw-flex">
          <div class="tw-w-1/4">Password</div>
          <div class="tw-w-3/4">
            <GpText :text="consoleAccessCredentials.password" allow-copy is-password />
          </div>
        </div>
        <p>
          <br />
        </p>
        <br />
      </div>
    </template>
    <template #footer>
      <div class="tw-flex tw-flex-wrap tw-justify-center tw-gap-4">
        <ModalFooterBtn label="Cancel" btn-type="cancel" size="sm" @click="emit('close')" />
        <ModalFooterBtn size="sm" btn-type="primary" label="Open console" @click="openInNewTab">
          Open console
          <FontAwesomeIcon :icon="faArrowUpRightFromSquare" class="tw-ml-1" />
        </ModalFooterBtn>
      </div>
    </template>
  </GpModal>
</template>
